module.exports = __webpack_public_path__ + "img/postfinance-card.fa34f2aa.svg";